/**
 * Títulos y descripciones de `<title>` / `<meta name="description">`.
 *
 * Viven juntos y no dentro de cada pantalla porque son lo que se ve en la
 * pestaña, en el historial y en el resultado de una búsqueda: conviene poder
 * leerlos de corrido y notar si dos páginas se anuncian igual.
 *
 * El sufijo `— ILUMETRIA` se escribe completo en cada entrada en vez de
 * componerse en código: hay idiomas donde el separador o el orden cambian.
 */

export const meta = {
  home: {
    title: 'ILUMETRIA — El Google Analytics para eventos físicos',
    description:
      'Plataforma de inteligencia de datos que ilumina el ROI de tus eventos presenciales con IoT e IA: matchmaking, captura pasiva de leads y atribución directa.',
  },
  contacto: {
    title: 'Contacto y demo — ILUMETRIA',
    description:
      'Agenda una demo de ILUMETRIA, solicita un plan personalizado o una letter of intent para tu próximo evento.',
  },
  panelInversionista: 'Tracción para inversionistas — ILUMETRIA',
  portero: 'Quién tiene acceso — ILUMETRIA',
  recuperar: 'Cambiar tu contraseña — ILUMETRIA',
  accesoInversionista: 'Acceso para inversionistas — ILUMETRIA',
  demoSensores: 'Demostración del producto — ILUMETRIA',
  accesoDemo: 'Panel de marca, demostración — ILUMETRIA',
  noEncontrada: 'Página no encontrada — ILUMETRIA',
};
